<template>
  <div>
    <div class="container-pagina-preview-init">
      <div class="container-local-reports">
        <div class="container-local-reports-title">{{ $t("local-reports") }}</div>
        <div class="container-local-reports-list">
          <div class="init-list-text">{{ $t("configure-your-own-local-report") }}:</div>
          <ol>
            <li class="instructions-report--1">{{ $t("instructions-reports-1") }}</li>
            <li class="instructions-report--2">{{ $t("instructions-reports-2") }}</li>
            <li class="instructions-report--3">{{ $t("instructions-reports-3") }}</li>
            <li class="instructions-report--4">
              {{ $t("click-on") }} <el-button class="btn-primary-brains btn-brains-header">{{ $t("generate-report") }}</el-button> {{ $t("instructions-reports-4") }}
            </li>
            <li class="instructions-report--5">
              {{ $t("click-on") }} <el-button class="btn-primary-brains btn-brains-header">{{ $t("download-report") }}</el-button> {{ $t("instructions-reports-5") }}
            </li>
          </ol>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PreviewInit'
}
</script>

<style lang="scss" scoped>
.container-pagina-preview-init {
  width: 960px;
  height: 640px;
  padding: 30px;
  font-family: "Montserrat-Regular",sans-serif;
  display: flex;
  flex-direction: column;
  align-items: center;

  .container-aura-reports {
    width: 60%;
    margin-top: 30px;

    .container-aura-reports-title {
      font-family: "Montserrat-ExtraBold",sans-serif;
      font-size: 24px;
      columns: #333333;
    }

    .container-aura-reports-list {
      padding-left: 35px;
      margin-top: 25px;
      font-size: 16px;
      font-family: "Montserrat-Light",sans-serif;
      color: #333333;

      .container-aura-reports--link {
        margin-bottom: 15px;

        a {
          font-family: "Montserrat-SemiBold",sans-serif;
          color: #00b1ff;
        }
      }
    }
  }

  .container-local-reports {
    width: 60%;
    .container-local-reports-title {
      font-family: "Montserrat-ExtraBold",sans-serif;
      font-size: 24px;
      columns: #333333;
    }

    .container-local-reports-list {
      padding-left: 35px;
      margin-top: 25px;
      font-size: 16px;
      font-family: "Montserrat-Light",sans-serif;
      color: #333333;

      .init-list-text {
        margin-bottom: 25px;
      }

      ol {
        list-style: decimal;
        padding-left: 17px;
        li {
          margin-bottom: 15px;
        }

        .instructions-report {
          &--1,
          &--2 {
            margin-bottom: 25px;
          }
          &--3 {
            margin-bottom: 21px;
          }
        }
      }
    }
  }
}
</style>
